'use client';
import React from 'react';
import Image from 'next/image';

interface RecipeSectionProps {
  className?: string;
  backgroundImage?: string;
  overlayImage?: string;
  height?: string;
}

const RecipeSection: React.FC<RecipeSectionProps> = ({ 
  className = '',
  backgroundImage = '/images/img_shutterstock2502968219_1.png',
  overlayImage = '/images/img_receta_1.png',
  height = 'h-[526px]'
}) => {
  return (
    <div data-component-id="src/components/sections/RecipeSection.tsx:19:4" data-component-path="src/components/sections/RecipeSection.tsx" data-component-line="19" data-component-file="RecipeSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${className}`}>
      <div data-component-id="src/components/sections/RecipeSection.tsx:20:6" data-component-path="src/components/sections/RecipeSection.tsx" data-component-line="20" data-component-file="RecipeSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`relative rounded-[20px] overflow-hidden ${height}`}>
        <Image data-component-id="src/components/sections/RecipeSection.tsx:21:8" data-component-path="src/components/sections/RecipeSection.tsx" data-component-line="21" data-component-file="RecipeSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3AbackgroundImage%5D%22%2C%22alt%22%3A%22Recipe%20Background%22%2C%22className%22%3A%22absolute%20inset-0%20w-full%20h-full%20object-cover%22%7D"
          src={backgroundImage}
          alt="Recipe Background"
          width={1406}
          height={526}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <Image data-component-id="src/components/sections/RecipeSection.tsx:28:8" data-component-path="src/components/sections/RecipeSection.tsx" data-component-line="28" data-component-file="RecipeSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3AoverlayImage%5D%22%2C%22alt%22%3A%22Recipe%22%2C%22className%22%3A%22absolute%20inset-0%20w-full%20h-full%20object-cover%22%7D"
          src={overlayImage}
          alt="Recipe"
          width={1406}
          height={526}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default RecipeSection; 